import { Box, Slider, Typography } from '@mui/material';
import { courseCardMediaSx, getCourseAvatarObjectPosition } from './courseCardImage';

interface CourseAvatarPositionEditorProps {
  imageUrl: string;
  positionX: number;
  positionY: number;
  onChange: (positionX: number, positionY: number) => void;
}

const CourseAvatarPositionEditor = ({
  imageUrl,
  positionX,
  positionY,
  onChange,
}: CourseAvatarPositionEditorProps) => (
  <Box className="w-full max-w-sm mt-16">
    <Typography variant="body2" color="text.secondary" className="mb-12">
      Encuadre en tarjeta de curso
    </Typography>
    <Box
      sx={{
        ...courseCardMediaSx(positionX, positionY),
        width: '100%',
        borderRadius: 2,
        border: '1px solid',
        borderColor: 'divider',
        backgroundImage: `url(${imageUrl})`,
      }}
    />
    <Typography variant="caption" color="text.secondary" className="mt-8 block">
      Vista previa igual que en Mis cursos. Por defecto la imagen se ancla abajo, como en producción.
    </Typography>
    <Typography variant="body2" className="mt-16 mb-4">
      Posición vertical
    </Typography>
    <Slider
      size="small"
      value={positionY}
      min={0}
      max={100}
      valueLabelDisplay="auto"
      valueLabelFormat={(v) => `${v}%`}
      onChange={(_, value) => onChange(positionX, value as number)}
      aria-label="Posición vertical de la imagen"
    />
    <Typography variant="body2" className="mt-8 mb-4">
      Posición horizontal
    </Typography>
    <Slider
      size="small"
      value={positionX}
      min={0}
      max={100}
      valueLabelDisplay="auto"
      valueLabelFormat={(v) => `${v}%`}
      onChange={(_, value) => onChange(value as number, positionY)}
      aria-label="Posición horizontal de la imagen"
    />
    <Typography variant="caption" color="text.secondary">
      Encuadre actual: {getCourseAvatarObjectPosition(positionX, positionY)}
    </Typography>
  </Box>
);

export default CourseAvatarPositionEditor;
